export const DATE_TIME = 'YYYY/MMM/DD hh:mm A';
export const DATE = 'YYYY/MMM/DD';

export const DATE_TIME_ALT = 'yyyy/mmm/dd hh:mm a';
